if (document.querySelectorAll('.resort-review').length > 0) {
  function setupPhotoGallery() {
    const $ = (window).jQuery;
    if ($('[data-fancybox="review-image"]').length === 0) return;

    $.fancybox.defaults.hash = false;
    $('[data-fancybox="review-image"]').fancybox({
      toolbar: 'true',
      buttons: [
        'close',
      ],
      beforeShow: () => {
        $(".fancybox-toolbar").css('transform', 'scale(1.4)');
        $(".fancybox-button--arrow_right").css('transform', 'scale(1.4)');
        $(".fancybox-button--arrow_left").css('transform', 'scale(1.4)');
      },
    });
    $('a.open-gallery').fancybox({
      beforeShow: () => {
        $("body").css({'overflow-y':'hidden'});
        $(".fancybox-toolbar").addClass('mt-3 mr-1 mr-sm-5');
        $(".fancybox-toolbar").css('transform', 'scale(1.4)');
      },
      afterClose: () => {
        $("body").css({'overflow-y':'visible'});
      },
      touch: false,
      height: 'auto',
      autoSize: false,
      scrolling: 'yes',
      smallBtn: false,
      toolbar: 'true',
      buttons: [
        'close',
      ],
    });
  }

  setupPhotoGallery();
}
